import type { Paragraph } from '@/api/types/stowed-element'

/**
 * True when two panel paragraph lists hold the same paragraphs: element by element, the same object
 * or the same content. Content is compared only for elements that aren't the same object — in
 * practice the small default paragraphs a shape with no text yet gets on every read.
 */
export function samePanelParagraphs(a: Paragraph[] | null, b: Paragraph[] | null): boolean {
  if (a === b) return true
  if (a === null || b === null || a.length !== b.length) return false

  return a.every((paragraph, i) => {
    const other = b[i]

    return paragraph === other || JSON.stringify(paragraph) === JSON.stringify(other)
  })
}
